import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from '@mui/material';
import { getDatabase, ref, get } from 'firebase/database';

const Trainers = () => {
  const [trainersData, setTrainersData] = useState([]);
  const [sortOption, setSortOption] = useState('name');
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const fetchTrainersData = async () => {
      try {
        const db = getDatabase();
        const trainersRef = ref(db, 'trainers');
        const trainersSnapshot = await get(trainersRef);

        if (trainersSnapshot.exists()) {
          const trainers = Object.values(trainersSnapshot.val());
          setTrainersData(trainers);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchTrainersData();
  }, []);

  const handleSortChange = (event) => {
    setSortOption(event.target.value);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredTrainers = trainersData.filter((trainer) => {
    if (searchQuery.trim() === '') {
      return true;
    } else {
      const searchValue = searchQuery.toLowerCase();
      return (
        trainer.name.toLowerCase().includes(searchValue) ||
        trainer.email.toLowerCase().includes(searchValue)
      );
    }
  });

  const sortedTrainers = filteredTrainers.sort((a, b) => {
    if (sortOption === 'name') {
      return a.name.localeCompare(b.name);
    } else if (sortOption === 'age') {
      return a.age - b.age;
    } else if (sortOption === 'experience') {
      return b.experience - a.experience;
    } else if (sortOption === 'workingHours') {
      return b.hours - a.hours;
    } else if (sortOption === 'monthlyCharge') {
      return a.monthlyCharge - b.monthlyCharge;
    } else {
      return 0;
    }
  });

  return (
    <Box>
      <Typography variant="h4" component="h1" align="center" gutterBottom marginTop={10}>
        Trainers
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '40px', marginTop:'40px', marginLeft:'180px' }}>
        <FormControl variant="outlined" size="small">
          <InputLabel>Sort By</InputLabel>
          <Select value={sortOption} onChange={handleSortChange}
          sx={{
            bgcolor:'#FF2625',
            color:'#FFFFFF',
            textTransform:'none',
            width:{lg:'175px', xs:'80px'},
            fontSize:{lg:'20px',xs:'14px'},
            height:'40px',
            position:'absolute',
            right:'0'
        }}
          >
            <MenuItem value="name">Name</MenuItem>
            <MenuItem value="age">Age</MenuItem>
            <MenuItem value="experience">Experience</MenuItem>
            <MenuItem value="workingHours">Working Hours</MenuItem>
            <MenuItem value="monthlyCharge">Monthly Charge</MenuItem>
          </Select>
        </FormControl>
        <TextField
          variant="outlined"
          size="small"
          value={searchQuery}
          onChange={handleSearchChange}
          sx={{
            input:{fontWeight:'700',border:'none', borderRadius:'4px'},
            width:{lg:'1000px',xs:'350px'},
            backgroundColor:'#FFFFFF',
        }}
        height={"76px"}
        placeholder='Find Trainers'
        type='text'
        />
      </Box>

      {sortedTrainers.length > 0 ? (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '20px',
            justifyContent: 'center',
          }}
        >
          {sortedTrainers.map((trainer) => (
            <Card key={trainer.email} sx={{ backgroundColor: '#f5f5f5', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}>
              <CardHeader
                title={trainer.name}
                sx={{
                  backgroundColor: '#94b1e6',
                  color: 'white',
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontSize: '20px',
                  padding: '10px',
                }}
              />
              <CardContent>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Age:</strong> {trainer.age}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Email:</strong> {trainer.email}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Experience:</strong> {trainer.experience} years
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Knowledge:</strong> {trainer.knowledge}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Working Hours:</strong> {trainer.hours}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Contact Number:</strong> {trainer.contactNumber}
                </Typography>
                <Typography variant="body1">
                  <strong>Monthly Charge:</strong> {trainer.monthlyCharge} rupees
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      ) : (
        <Typography variant="body1" align="center">
          No trainers found.
        </Typography>
      )}
    </Box>
  );
};

export default Trainers;
